import * as yup from "yup";

const onlyDigitsRegex= /^\d+$/;

const getOnlyDigitsMsg= (property) => `${property} must be digits only`;

const monthLenErrorMsg= "Expire Month must be exactly 2 digits";
const yearLenErrorMsg= "Expire Year must be exactly 4 digits";

const monthNumberErrorMsg= "Expire Month must be digits only";
const yearNumberErrorMsg= "Expire Year must be digits only";

export const ccNewSchema= yup.object().shape({
  assignedUserID: yup.number().required("Assigned User is required"),
  cardTypeID: yup.number().required("Card Type is required"),
  cardBrandID: yup.number().required("Card Brand is required"),
  nameOnCard: yup.string().required("Name On Card is required").min(4).matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed in Name on Card"),
  cardNumber: yup.string().required("Card Number is required").min(12).max(20).matches(onlyDigitsRegex, getOnlyDigitsMsg("Card Number") ),
  cvvCode: yup.string().required("CVV Code is required").min(3).max(4).matches(onlyDigitsRegex, getOnlyDigitsMsg("Cvv Code") ),
  additionalCode: yup.string().notRequired().nullable().matches(/^\d+$/, {message: getOnlyDigitsMsg("Additional Code"), excludeEmptyString: true}),
  expirMonth: yup.string().required("EXP Month is required").min(2, monthLenErrorMsg).max(2, monthLenErrorMsg ).matches(onlyDigitsRegex, monthNumberErrorMsg),
  expirYear:yup.string().required("EXP Year is required").min(4, yearLenErrorMsg).max(4, yearLenErrorMsg).matches(onlyDigitsRegex, yearNumberErrorMsg),
});
// A: validation for new credit cards cardNumber and cvv Code are required

export const ccEditSchema=yup.object().shape({
  assignedUserID: yup.number().required("Assigned User is required"),
  cardTypeID: yup.number().required("Card Type is required"),
  cardBrandID: yup.number().required("Card Brand is required"),
  nameOnCard: yup.string().required("Name On Card is required").min(4).matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed in Name on Card"),
  cardNumber: yup.string().min(12).max(20).matches(onlyDigitsRegex, getOnlyDigitsMsg("Card Number") ),
  cvvCode: yup.string().min(3).max(4).matches(onlyDigitsRegex, getOnlyDigitsMsg("Cvv Code") ),
  additionalCode: yup.string().notRequired().nullable().matches(/^\d+$/, {message: getOnlyDigitsMsg("Additional Code"), excludeEmptyString: true}),
  expirMonth: yup.string().required("EXP Month is required").min(2, monthLenErrorMsg).max(2, monthLenErrorMsg ).matches(onlyDigitsRegex, monthNumberErrorMsg),
  expirYear:yup.string().required("EXP Year is required").min(4, yearLenErrorMsg).max(4, yearLenErrorMsg).matches(onlyDigitsRegex, yearNumberErrorMsg),
});
// A validation for edit CC 